import c from 'common/constants/flux-events';

function getInitialState() {
    return [];
}

export const NAME = 'resources.doohPublishers';

export default function reducer(state = getInitialState(), action) {
    switch (action.type) {
        case c.SYSTEM__DOOH_PUBLISHERS__FETCH__SUCCESS:
            const doohPublishers = action.payload;
            return doohPublishers;
        default:
            return state;
    }
}
